import { render } from "./quantity.vue?vue&type=template&id=1f64e9c6"
import script from "./quantity.vue?vue&type=script&lang=js"
export * from "./quantity.vue?vue&type=script&lang=js"

import "./quantity.vue?vue&type=style&index=0&id=1f64e9c6&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__